import React from 'react';
import { withUAPLThemedStyles } from '@bingads-webui-campaign-react/unified-ad-preview-library-core';

import { ImageAdWithLogoPlacementBase } from './image-ad-with-logo-placement-base';
import {
  getImageAdWithLogoPlacementStyles,
  getImageAdWithLogoPlacementWithImageStyles,
} from '../styles';

export const ImageAdWithLogoPlacementNoImage = withUAPLThemedStyles(
  props => (
    <ImageAdWithLogoPlacementBase
      {...props}
      showShortHeadline
      showUrl
      showRating
      showRatingPoint
      showDescription
      showCallToAction
    />
  ),
  getImageAdWithLogoPlacementStyles,
  { componentName: 'ImageAdWithLogoPlacementNoImage' }
);

export const ImageAdWithLogoPlacementWithImage = withUAPLThemedStyles(
  props => (
    <ImageAdWithLogoPlacementBase
      {...props}
      showShortHeadline
      showLongHeadline
      showPrice
      showLocation
      showDescription
      showCallToAction
      showAdInfoLabel
      isAdInfoLabelWithText
    />
  ),
  getImageAdWithLogoPlacementWithImageStyles,
  { componentName: 'ImageAdWithLogoPlacementWithImage' }
);
